import React, { Component } from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const styles = (theme) => ({
  standaloneRoot: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  standaloneDescription: {
    marginBottom: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  standaloneControl: {
    maxWidth: 400,
    marginBottom: theme.spacing(1),
  },
  toolbarRoot: {
    minWidth: 200,
    maxWidth: 320,
  },
  modalRoot: {
    width: '100%',
  },
  modalControl: {
    width: '100%',
    maxWidth: 'none',
  },
});

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 220,
    },
  },
};

class SelezioneGruppo extends Component {
  handleSelection = (event) => {
    const id = event.target.value;
    this.props.onGruppoSelected(id);
  };

  render() {
    const { classes, gruppoId, gruppi, disabled, description, layout } =
      this.props;
    const gruppoid = gruppoId !== null ? gruppoId : '';

    const isToolbar = layout === 'toolbar';
    const isModal = layout === 'modal';

    const controlClass = isToolbar
      ? classes.toolbarRoot
      : isModal
        ? classes.modalControl
        : classes.standaloneControl;

    const toolbarLabel = 'Gruppo';
    const defaultLabel = 'Seleziona un gruppo';
    const inputLabel = isToolbar ? toolbarLabel : defaultLabel;
    const modalShowFloatingLabel = isModal && gruppoid === '';

    const select = (
      <FormControl
        variant="outlined"
        size="small"
        disabled={disabled}
        className={controlClass}
        fullWidth={!isToolbar}
      >
        {(!isModal || modalShowFloatingLabel) && (
          <InputLabel id="gruppo-label">{inputLabel}</InputLabel>
        )}
        <Select
          {...(modalShowFloatingLabel || !isModal
            ? {
                labelId: 'gruppo-label',
                label: inputLabel,
              }
            : {
                inputProps: { 'aria-label': defaultLabel },
              })}
          variant="outlined"
          value={gruppoid}
          name="id"
          onChange={this.handleSelection}
          disabled={disabled}
          MenuProps={MenuProps}
          displayEmpty={isModal}
        >
          {gruppi.map((value) => (
            <MenuItem key={value.id} value={value.id}>
              {value.nome}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );

    if (isToolbar) {
      return <Box>{select}</Box>;
    }

    if (isModal) {
      return (
        <Box className={classes.modalRoot}>
          {description ? (
            <Typography
              variant="body2"
              component="p"
              className={classes.standaloneDescription}
            >
              {description}
            </Typography>
          ) : null}
          {select}
        </Box>
      );
    }

    return (
      <Box className={classes.standaloneRoot}>
        {description ? (
          <Typography
            variant="body2"
            component="p"
            className={classes.standaloneDescription}
          >
            {description}
          </Typography>
        ) : null}
        {select}
      </Box>
    );
  }
}

SelezioneGruppo.defaultProps = {
  layout: 'standalone',
};

SelezioneGruppo.propTypes = {
  classes: PropTypes.object.isRequired,
  gruppoId: PropTypes.number,
  gruppi: PropTypes.array.isRequired,
  disabled: PropTypes.bool.isRequired,
  description: PropTypes.string.isRequired,
  onGruppoSelected: PropTypes.func.isRequired,
  layout: PropTypes.oneOf(['standalone', 'toolbar', 'modal']),
};

export default withStyles(styles)(SelezioneGruppo);
